import AuthCodePage from './AuthCodePage-Container';
export default AuthCodePage;
